import apiClient from "./axios"

const base = importerId => `/vehicle-importers/${importerId}/bank-accounts`

export const getVehicleImporterBankAccounts = async (importerId, params = {}) => {
  const { data } = await apiClient.get(base(importerId), { params })
  return data
}

export const getVehicleImporterBankAccount = async (importerId, id) => {
  const { data } = await apiClient.get(`${base(importerId)}/${id}`)
  return data
}

export const createVehicleImporterBankAccount = async ({ importerId, ...payload }) => {
  const { data } = await apiClient.post(base(importerId), payload)
  return data
}

export const updateVehicleImporterBankAccount = async ({ importerId, id, ...payload }) => {
  const { data } = await apiClient.patch(`${base(importerId)}/${id}`, payload)
  return data
}

export const deleteVehicleImporterBankAccount = async (importerId, id) => {
  const { data } = await apiClient.delete(`${base(importerId)}/${id}`)
  return data
}

export const setDefaultVehicleImporterBankAccount = async (importerId, id) => {
  const { data } = await apiClient.post(`${base(importerId)}/${id}/set-default`)
  return data
}
